import { routing } from "../../routing.js";
export function createClient(api) {
  async function subscribeToNewsroom(newsroomId, payload) {
    const url = routing.newsroomSubscribeUrl.replace(':newsroom_id', String(newsroomId));
    const {
      subscription
    } = await api.post(url, {
      payload
    });
    return subscription;
  }
  async function unsubscribeFromNewsroom(newsroomId, payload) {
    const url = routing.newsroomUnsubscribeUrl.replace(':newsroom_id', String(newsroomId));
    const {
      subscription
    } = await api.post(url, {
      payload
    });
    return subscription;
  }
  async function updateNewsroomUnsubscribeDetails(newsroomId, subscriptionId, payload) {
    const url = routing.newsroomUnsubscribeUrl.replace(':newsroom_id', String(newsroomId));
    const {
      subscription
    } = await api.patch(`${url}/${subscriptionId}`, {
      payload
    });
    return subscription;
  }
  async function unsubscribeFromLicense(payload) {
    const url = routing.licenseUnsubscribeUrl;
    const {
      subscription
    } = await api.post(url, {
      payload
    });
    return subscription;
  }
  async function updateLicenseUnsubscribeDetails(subscriptionId, payload) {
    const url = routing.licenseUnsubscribeUrl;
    const {
      subscription
    } = await api.patch(`${url}/${subscriptionId}`, {
      payload
    });
    return subscription;
  }
  return {
    subscribeToNewsroom,
    unsubscribeFromNewsroom,
    unsubscribeFromLicense,
    updateNewsroomUnsubscribeDetails,
    updateLicenseUnsubscribeDetails
  };
}